<script setup lang="ts">
defineProps<{ icon: string; hasParent: boolean }>();
</script>
<template>
  <i v-if="hasParent" :class="icon" class="tw-relative tw-mr-1">
    <i class="fas fa-envelope fa-xs tw-absolute -tw-bottom-0 -tw-right-1"></i>
  </i>
  <i v-else :class="icon"></i>
</template>
